import { ProductKindEnum } from '@koob/enums';

export const PRICING_CATEGORIES = [
  { id: 'hotels', label: 'Hotels' },
  { id: 'experiences', label: 'Experiences' },
  { id: 'additional-services', label: 'Additional services' },
];

const categoryByType = {
  hotel: ProductKindEnum.HOTELS,
  hotels: ProductKindEnum.HOTELS,
  experience: ProductKindEnum.EXPERIENCES,
  experiences: ProductKindEnum.EXPERIENCES,
  activity: ProductKindEnum.EXPERIENCES,
  program: ProductKindEnum.EXPERIENCES,
};

export const getPricingCategory = (item) => {
  const explicitCategory = item?.category
    ?.toLowerCase?.()
    .replace(/[_ ]/g, '-');
  if (explicitCategory === ProductKindEnum.HOTELS)
    return ProductKindEnum.HOTELS;
  if (explicitCategory === ProductKindEnum.EXPERIENCES)
    return ProductKindEnum.EXPERIENCES;
  if (explicitCategory === ProductKindEnum.ADDITIONAL_SERVICES)
    return ProductKindEnum.ADDITIONAL_SERVICES;

  return categoryByType[item?.type?.toLowerCase()] || 'additional-services';
};

export const getPricingItemAmount = (item, useConvertedPrice = false) => {
  const isCancelled = ['cancelled', 'canceled'].includes(
    item?.state?.toLowerCase(),
  );

  if (isCancelled && item?.cancellationFee == null) return null;

  if (useConvertedPrice) {
    return item?.convertedPrice != null ? Number(item.convertedPrice) : null;
  }

  if (isCancelled) {
    return Number(item.cancellationFee);
  }

  return Number(item?.price ?? 0);
};

const dateValue = (item) => {
  const value = item?.startAt || item?.date;
  const timestamp = value ? new Date(value).getTime() : 0;
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

/**
 * The canonical display model consumed by both pricing details and the diary.
 * It deliberately keeps the original service objects so editing remains possible.
 */
export const buildPricingDisplay = ({
  services = [],
  markup = 0,
  isMarkupPercent = true,
  displayMode = 'itemized',
  useConvertedPrice = false,
} = {}) => {
  const categories = PRICING_CATEGORIES.map((category) => {
    const items = services
      .filter((item) => getPricingCategory(item) === category.id)
      .filter((item) => getPricingItemAmount(item, useConvertedPrice) != null)
      .sort((a, b) => dateValue(a) - dateValue(b));

    return {
      ...category,
      items,
      subtotal: items.reduce(
        (sum, item) =>
          sum + (getPricingItemAmount(item, useConvertedPrice) || 0),
        0,
      ),
    };
  });

  return {
    displayMode,
    categories,
    total: categories.reduce((sum, category) => sum + category.subtotal, 0),
    markup: Number(markup || 0),
    isMarkupPercent,
  };
};
